import {
  CAMPAIGN_TYPE_LABELS,
  getTemplateBlueprint,
  STANDARD_TEMPLATE_VARIABLES,
  type TemplateCategory,
} from '@marketing-hub/shared';
import campStyles from '@/features/campaigns/Campaigns.module.css';

type Props = {
  category: TemplateCategory;
  onApplyStructure?: () => void;
  applyDisabled?: boolean;
};

export function TemplateStructurePanel({ category, onApplyStructure, applyDisabled }: Props) {
  const blueprint = getTemplateBlueprint(category);

  return (
    <aside className={campStyles.templateStructure} aria-label="Template structuur">
      <div className={campStyles.templateStructureHead}>
        <p className={campStyles.templateStructureTitle}>
          Structuur — {CAMPAIGN_TYPE_LABELS[category]}
        </p>
        {onApplyStructure ? (
          <button
            type="button"
            className={campStyles.templateStructureApply}
            disabled={applyDisabled}
            onClick={onApplyStructure}
          >
            Structuur toepassen
          </button>
        ) : null}
      </div>
      <ol className={campStyles.templateStructureList}>
        {blueprint.structure_steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
      <p className={campStyles.templateStructureVars}>
        Variabelen: {STANDARD_TEMPLATE_VARIABLES.join(' · ')}
      </p>
    </aside>
  );
}
